import styled from "styled-components";

export const WrapperAction = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;

  .ant-btn {
    margin: 0px auto;
    border-color: transparent;
    background: transparent;
    width: 40px;
    height: 40px;
    box-shadow: none;
    color: #747c84;

    .anticon {
      padding-top: 3px;
      font-size: 24px;
    }

    &:hover,
    &:focus {
      font-weight: bold;
      border-color: transparent;
      background: #e8e8e8;
      color: ${({ colorHover, theme }) => theme[`@${colorHover}`]};
    }
  }
`;

export const Title = styled.p`
  font-size: 9px;
  color: #747c84;
  text-align: center;
  margin-bottom: 20px;
`;
